import { createElement, Fragment, ReactChild } from 'react';
import urlRegexSafe from 'url-regex-safe';

type Props = {
  text: string;
  children: (url: string, key: string) => ReactChild;
};

const Linkify = ({ text, children }: Props) => {
  const urls = text.match(urlRegexSafe());

  let replaced: ReactChild[] = [text];

  if (!urls || urls.length <= 0) {
    return <Fragment>{replaced}</Fragment>;
  }

  for (const url of urls) {
    replaced = replaced.reduce((arr, item, i) => {
      if (typeof item === 'string') {
        return [
          ...arr,
          ...item
            .split(url)
            .reduce(
              (splitted, part, j) =>
                j === 0 ? [...splitted, part] : [...splitted, children(url, `url-${i}-${j}`), part],
              [] as ReactChild[],
            ),
        ];
      } else {
        return [...arr, item];
      }
    }, [] as ReactChild[]);
  }

  return <Fragment>{replaced}</Fragment>;
};

export default Linkify;
